import React from 'react'

const LoadSpinnerIcon = () => {
  return (
    <div className="d-flex justify-content-center text-secondary">
      <div className="spinner-border" style={{width:"20px", height:"20px"}} role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

export default LoadSpinnerIcon